import React from 'react';
import DialogContentText from '@material-ui/core/DialogContentText';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Table from '@material-ui/core/Table';
import { makeStyles } from '@material-ui/core/styles';
import { formatPrice } from '../helper';

const useStyles = makeStyles(() => ({
  tableBody: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      padding: '1px 0 0 0',
    },
  },
  upsellNote: {
    fontStyle: 'italic',
    fontSize: '.7rem',
  },
}));

const RecurringPlanCostPreview = ({ sw }) => {
  const {
    shop_fee_dollars,
    sales_tax_dollars,
    coupon_code,
    coupon_amount_dollars,
    custom_discount_amount_dollars,
    total_taxed_price_dollars,
  } = sw || {};

  const classes = useStyles();

  return (
    <DialogContentText>
      <Table size="small">
        <TableBody className={classes.tableBody}>
          {sw?.services
            .filter((s) => !s.is_upsell)
            .map((s) => (
              <TableRow>
                <TableCell colSpan={2}>{s.short_name}</TableCell>
                <TableCell align="right">
                  {formatPrice(s.total_cost_dollars)}
                </TableCell>
              </TableRow>
            ))}
          <TableRow>
            <TableCell colSpan={2}>Taxes and Fee</TableCell>
            <TableCell align="right">
              {formatPrice(sales_tax_dollars + shop_fee_dollars)}
            </TableCell>
          </TableRow>
          {(!!coupon_code || !!coupon_amount_dollars) && (
            <TableRow>
              <TableCell colSpan={2}>Coupon {coupon_code}</TableCell>
              <TableCell align="right">
                - {formatPrice(coupon_amount_dollars)}
              </TableCell>
            </TableRow>
          )}
          {!!custom_discount_amount_dollars && (
            <TableRow>
              <TableCell colSpan={2}>Custom Discount</TableCell>
              <TableCell align="right">
                - {formatPrice(custom_discount_amount_dollars)}
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell colSpan={2}>
              <strong>Total</strong>
            </TableCell>
            <TableCell align="right">
              <strong>{formatPrice(total_taxed_price_dollars)}</strong>
            </TableCell>
          </TableRow>
          {sw?.services.some((s) => s.is_upsell) && (
            <TableRow>
              <TableCell colSpan={2} className={classes.upsellNote}>
                Note: Upsells are not included in Repeat Appointments. If you
                want to add extra services, please create new Repeat
                Appointments using the plus button in the bottom-right of the
                screen.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </DialogContentText>
  );
};

export default RecurringPlanCostPreview;
